import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Digest1vc95ftpmqvn1 as Digest } from '../../../../../core-library-digest/org/kotlincrypto/core/digest/Digest.mjs';
import { Bit3217m1n1f00xdaa as Bit32 } from '../../../../../bitops-library-bits/org/kotlincrypto/bitops/bits/Counter.mjs';
import { Little_getInstance3o64tamm9djeo as Little_getInstance } from '../../../../../bitops-library-endian/org/kotlincrypto/bitops/endian/Endian.mjs';
import { rotateLeft386qqkr4zb8q2 as rotateLeft } from '../../../../../kotlin-kotlin-stdlib/kotlin/NumbersJs.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  fill3lmv1pckd4inv as fill,
  fill2542d4m9l93pn as fill_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { arrayCopytctsywo3h7gj as arrayCopy } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.o3o_1 = 64;
        var tmp = this;
        // Inline function 'kotlin.intArrayOf' call
        tmp.p3o_1 = new Int32Array([1732584193, -271733879, -1732584194, 271733878]);
        var tmp_0 = this;
        // Inline function 'kotlin.intArrayOf' call
        tmp_0.q3o_1 = new Int32Array([7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21]);
        var tmp_1 = this;
        // Inline function 'kotlin.intArrayOf' call
        tmp_1.r3o_1 = new Int32Array([-680876936, -389564586, 606105819, -1044525330, -176418897, 1200080426, -1473231341, -45705983, 1770035416, -1958414417, -42063, -1990404162, 1804603682, -40341101, -1502002290, 1236535329, -165796510, -1069501632, 643717713, -373897302, -701558691, 38016083, -660478335, -405537848, 568446438, -1019803690, -187363961, 1163531501, -1444681467, -51403784, 1735328473, -1926607734, -378558, -2022574463, 1839030562, -35309556, -1530992060, 1272893353, -155497632, -1094730640, 681279174, -358537222, -722521979, 76029189, -640364487, -421815835, 530742520, -995338651, -198630844, 1126891415, -1416354905, -57434055, 1700485571, -1894986606, -1051523, -2054922799, 1873313359, -30611744, -1560198380, 1309151649, -145523070, -1120210379, 718787259, -343485551]);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function init_org_kotlincrypto_hash_md_MD5(_this__u8e3s4) {
  Companion_getInstance();
}
var MD5Class;
function MD5() {
  if (MD5Class === VOID) {
    class $ extends Digest() {
      static z3o() {
        Companion_getInstance();
        var $this = this.c3n('MD5', 64, 16);
        init_org_kotlincrypto_hash_md_MD5($this);
        $this.w3o_1 = new Int32Array(16);
        var tmp = $this;
        // Inline function 'kotlin.collections.copyOf' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.x3o_1 = Companion_getInstance().p3o_1.slice();
        $this.y3o_1 = Bit32().a3o(64);
        return $this;
      }
      j3n(input, offset) {
        var k = Companion_getInstance().r3o_1;
        var s = Companion_getInstance().q3o_1;
        var x = this.w3o_1;
        var state = this.x3o_1;
        var a = state[0];
        var b = state[1];
        var c = state[2];
        var d = state[3];
        var inductionVariable = 0;
        if (inductionVariable < 16)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            Little_getInstance();
            // Inline function 'org.kotlincrypto.bitops.endian.Little.leIntAt' call
            var offset_0 = imul(i, 4) + offset | 0;
            var xi = Little_getInstance().l3o(input, offset_0);
            x[i] = xi;
            var f = (((b & c | ~b & d) + a | 0) + k[i] | 0) + xi | 0;
            a = d;
            d = c;
            c = b;
            b = b + rotateLeft(f, s[i]) | 0;
          }
           while (inductionVariable < 16);
        var inductionVariable_0 = 16;
        if (inductionVariable_0 < 32)
          do {
            var i_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var g = (imul(5, i_0) + 1 | 0) % 16 | 0;
            var f_0 = (((d & b | ~d & c) + a | 0) + k[i_0] | 0) + x[g] | 0;
            a = d;
            d = c;
            c = b;
            b = b + rotateLeft(f_0, s[i_0]) | 0;
          }
           while (inductionVariable_0 < 32);
        var inductionVariable_1 = 32;
        if (inductionVariable_1 < 48)
          do {
            var i_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var g_0 = (imul(3, i_1) + 5 | 0) % 16 | 0;
            var f_1 = (((b ^ c ^ d) + a | 0) + k[i_1] | 0) + x[g_0] | 0;
            a = d;
            d = c;
            c = b;
            b = b + rotateLeft(f_1, s[i_1]) | 0;
          }
           while (inductionVariable_1 < 48);
        var inductionVariable_2 = 48;
        if (inductionVariable_2 < 64)
          do {
            var i_2 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var g_1 = imul(7, i_2) % 16 | 0;
            var f_2 = (((c ^ (b | ~d)) + a | 0) + k[i_2] | 0) + x[g_1] | 0;
            a = d;
            d = c;
            c = b;
            b = b + rotateLeft(f_2, s[i_2]) | 0;
          }
           while (inductionVariable_2 < 64);
        state[0] = state[0] + a | 0;
        state[1] = state[1] + b | 0;
        state[2] = state[2] + c | 0;
        state[3] = state[3] + d | 0;
        this.y3o_1.b3o();
      }
      h3n(buf, bufPos) {
        var digest = new Int8Array(this.d3n());
        this.a3p(digest, 0, buf, bufPos);
        return digest;
      }
      a3p(dest, destOffset, buf, bufPos) {
        var tmp0_container = this.y3o_1.c3o(bufPos).s3n();
        var bitsLo = tmp0_container.we();
        var bitsHi = tmp0_container.xe();
        buf[bufPos] = -128;
        if ((bufPos + 1 | 0) > 56) {
          this.j3n(buf, 0);
          fill(buf, 0, 0, 56);
        }
        // Inline function 'org.kotlincrypto.bitops.endian.Little.lePackIntoUnsafe' call
        Little_getInstance();
        Little_getInstance().m3o(bitsLo, buf, 56);
        // Inline function 'org.kotlincrypto.bitops.endian.Little.lePackIntoUnsafe' call
        Little_getInstance();
        Little_getInstance().m3o(bitsHi, buf, 60);
        this.j3n(buf, 0);
        Little_getInstance();
        // Inline function 'org.kotlincrypto.bitops.endian.Little.lePackIntoUnsafe' call
        var this_0 = this.x3o_1;
        var sourceIndexEnd = this_0.length;
        Little_getInstance().n3o(this_0, dest, destOffset, 0, sourceIndexEnd);
      }
      i3n() {
        fill_0(this.w3o_1, 0);
        var tmp0 = Companion_getInstance().p3o_1;
        // Inline function 'kotlin.collections.copyInto' call
        var destination = this.x3o_1;
        var endIndex = tmp0.length;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp = tmp0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp, destination, 0, 0, endIndex);
        this.y3o_1.d3o();
      }
    }
    initMetadataForClass($, 'MD5', $.z3o);
    MD5Class = $;
  }
  return MD5Class;
}
//region block: exports
export {
  MD5 as MD5s71ietnk13uj,
};
//endregion

//# sourceMappingURL=MD5.mjs.map
